<div>
  <div class="modal__content" wfmScrollbar>
    <div class="flex">
      <div class="u--1/2 u-ph">
        <div class="form__fieldset eds-radio-override" *ngIf="dictatePrivilege || assignmentPrivilege">
          <div class="form__radio">
            <label for="assignment-on-sign-out" class="form__label form__label--top form__label--bottom">
              <span class="form__label-inner-wrap" id="assignment-on-sign-out">
                <span translate="userPreference.assignmentOnSignOutLabel"></span>
              </span>
            </label>
            <div>
              <label for="release-on-sign-out" class="radio" [class.radio--disabled]="isExternalApp">
                <input
                  id="release-on-sign-out"
                  type="radio"
                  name="assignment_on_signout"
                  class="radio__input"
                  [(ngModel)]="preferenceOnSignout"
                  [checked]="userPreferences['unassign-on-signout'] === 'release'"
                  (click)="updateUserPreference('unassign-on-signout', 'release')"
                  [disabled]="isExternalApp"
                  [ngClass]="{ 'radiobutton-selected': preferenceOnSignout === 'release' }"
                  value="release"
                />
                <span
                  id="release-on-sign-out-label"
                  class="radio__label"
                  translate="userPreference.alwaysReleaseLabel"
                ></span>
              </label>
            </div>
            <div>
              <label for="keep-on-sign-out" class="radio" [class.radio--disabled]="isExternalApp">
                <input
                  id="keep-on-sign-out"
                  type="radio"
                  name="assignment_on_signout"
                  class="radio__input"
                  [disabled]="isExternalApp"
                  [(ngModel)]="preferenceOnSignout"
                  [checked]="userPreferences['unassign-on-signout'] === 'keep'"
                  (click)="updateUserPreference('unassign-on-signout', 'keep')"
                  [ngClass]="{ 'radiobutton-selected': preferenceOnSignout === 'keep' }"
                  value="keep"
                />
                <span
                  id="keep-on-sign-out-label"
                  class="radio__label"
                  translate="userPreference.alwaysKeepLabel"
                ></span>
              </label>
            </div>
            <div>
              <label for="decide-on-sign-out" class="radio" [class.radio--disabled]="isExternalApp">
                <input
                  id="decide-on-sign-out"
                  type="radio"
                  name="assignment_on_signout"
                  class="radio__input"
                  [disabled]="isExternalApp"
                  [(ngModel)]="preferenceOnSignout"
                  [checked]="userPreferences['unassign-on-signout'] === 'decide'"
                  (click)="updateUserPreference('unassign-on-signout', 'decide')"
                  [ngClass]="{ 'radiobutton-selected': preferenceOnSignout === 'decide' }"
                  value="decide"
                />
                <span
                  id="decide-on-sign-out-label"
                  class="radio__label"
                  translate="userPreference.decideOnSignOutLabel"
                ></span>
              </label>
            </div>
          </div>
        </div>

        <div class="form__fieldset eds-radio-override" *ngIf="dictatePrivilege || assignmentPrivilege">
          <div class="form__radio">
            <label for="assignment-on-tab-closure" class="form__label form__label--top form__label--bottom">
              <span class="form__label-inner-wrap" id="assignment-on-tab-closure">
                <span translate="userPreference.assignmentOnTabClosureLabel"></span>
              </span>
            </label>
            <div>
              <label for="release-on-tab-closure" class="radio">
                <input
                  id="release-on-tab-closure"
                  type="radio"
                  name="assignment_on_tab_close"
                  class="radio__input"
                  [(ngModel)]="preferenceOnTabClose"
                  [checked]="userPreferences['unassign-on-tab-closure'] === 'release'"
                  (click)="updateUserPreference('unassign-on-tab-closure', 'release')"
                  [ngClass]="{ 'radiobutton-selected': preferenceOnTabClose === 'release' }"
                  value="release"
                />
                <span
                  id="release-on-tab-closure-label"
                  class="radio__label"
                  translate="userPreference.alwaysReleaseLabel"
                ></span>
              </label>
            </div>
            <div>
              <label for="keep-on-tab-closure" class="radio">
                <input
                  id="keep-on-tab-closure"
                  type="radio"
                  name="assignment_on_tab_close"
                  class="radio__input"
                  [(ngModel)]="preferenceOnTabClose"
                  [checked]="userPreferences['unassign-on-tab-closure'] === 'keep'"
                  (click)="updateUserPreference('unassign-on-tab-closure', 'keep')"
                  [ngClass]="{ 'radiobutton-selected': preferenceOnTabClose === 'keep' }"
                  value="keep"
                />
                <span
                  id="keep-on-tab-closure-label"
                  class="radio__label"
                  translate="userPreference.alwaysKeepLabel"
                ></span>
              </label>
            </div>
            <div>
              <label for="decide-on-tab-closure" class="radio">
                <input
                  id="decide-on-tab-closure"
                  type="radio"
                  name="assignment_on_tab_close"
                  class="radio__input"
                  [(ngModel)]="preferenceOnTabClose"
                  [checked]="userPreferences['unassign-on-tab-closure'] === 'decide'"
                  (click)="updateUserPreference('unassign-on-tab-closure', 'decide')"
                  [ngClass]="{ 'radiobutton-selected': preferenceOnTabClose === 'decide' }"
                  value="decide"
                />
                <span
                  id="decide-on-tab-closure-label"
                  class="radio__label"
                  translate="userPreference.decideOnTabClosureLabel"
                ></span>
              </label>
            </div>
          </div>
        </div>

        <div class="form__fieldset eds-checkbox-override">
          <div>
            <label for="ptHistory-text" class="form__label form__label--top form__label--bottom">
              <span class="form__label-inner-wrap" id="ptHistory-text">
                <span>{{ 'userPreference.ptHistoryDisplayLabel' | translate }}</span>
              </span>
            </label>
          </div>
          <div>
            <label for="hide_cancled_exams" class="checkbox">
              <input
                id="hide_cancled_exams"
                type="checkbox"
                class="checkbox__input"
                [(ngModel)]="userPreferences.hideCancelledExams"
                [ngClass]="{ 'checkbox-selected': userPreferences.hideCancelledExams === true }"
                (ngModelChange)="ptHistoryToggle('hideCancelledExams')"
              />
              <span id="hide_cancled_exams_label" class="checkbox__label">{{
                'userPreference.hideCancelledExamsLabel' | translate
              }}</span>
            </label>
          </div>
          <div>
            <label for="hide_scheduled_exams" class="checkbox">
              <input
                id="hide_scheduled_exams"
                type="checkbox"
                class="checkbox__input"
                [(ngModel)]="userPreferences.hideScheduledExams"
                [ngClass]="{ 'checkbox-selected': userPreferences.hideScheduledExams === true }"
                (ngModelChange)="ptHistoryToggle('hideScheduledExams')"
              />
              <span id="hide_scheduled_exams_label" class="checkbox__label">{{
                'userPreference.hideScheduledExamsLabel' | translate
              }}</span>
            </label>
          </div>
          <div>
            <label for="hide_ordered_exams" class="checkbox">
              <input
                id="hide_ordered_exams"
                type="checkbox"
                class="checkbox__input"
                [(ngModel)]="userPreferences.hideOrderedExams"
                [ngClass]="{ 'checkbox-selected': userPreferences.hideOrderedExams === true }"
                (ngModelChange)="ptHistoryToggle('hideOrderedExams')"
              />
              <span id="hide_ordered_exams_label" class="checkbox__label">{{
                'userPreference.hideOrderedExamsLabel' | translate
              }}</span>
            </label>
          </div>
        </div>

        <!--[Start]:Added for Take Control-->
        <div class="form__fieldset eds-radio-override" *ngIf="dictatePrivilege || assignmentPrivilege">
          <div class="form__radio">
            <label for="assignment-on-take-control" class="form__label form__label--top form__label--bottom">
              <span class="form__label-inner-wrap" id="assignment-on-take-control">
                <span translate="userPreference.takeControlDisplayLabel"></span>
              </span>
            </label>
            <div>
              <label for="discard-on-take-control" class="radio">
                <input
                  id="discard-on-take-control"
                  type="radio"
                  name="assignment_on_take_control"
                  class="radio__input"
                  [(ngModel)]="preferenceOnTakeControl"
                  [checked]="preferenceOnTakeControl === 'discard'"
                  (click)="updateUserPreference('save-report-on-release-control', 'discard')"
                  [ngClass]="{ 'radiobutton-selected': preferenceOnTakeControl === 'discard' }"
                  value="discard"
                />
                <span
                  id="discard-on-take-control-label"
                  class="radio__label"
                  translate="userPreference.takeControlAlwaysDiscard"
                ></span>
              </label>
            </div>
            <div>
              <label for="save-on-take-control" class="radio">
                <input
                  id="save-on-take-control"
                  type="radio"
                  name="assignment_on_take_control"
                  class="radio__input"
                  [(ngModel)]="preferenceOnTakeControl"
                  [checked]="preferenceOnTakeControl === 'save'"
                  (click)="updateUserPreference('save-report-on-release-control', 'save')"
                  [ngClass]="{ 'radiobutton-selected': preferenceOnTakeControl === 'save' }"
                  value="save"
                />
                <span
                  id="save-on-take-control-label"
                  class="radio__label"
                  translate="userPreference.takeControlAlwaysSave"
                ></span>
              </label>
            </div>
          </div>
        </div>
        <!--[Ended]:Added for Take Control-->
      </div>

      <div class="u--1/2 search-input-text-override">
        <div class="u-pb---">
          <div>
            <label class="form__label form__label--top form__label--bottom">
            <span class="form__label-inner-wrap">
              <span translate="userPreference.setDefaultWorklistlabel"></span>
            </span>
            </label>
          </div>
          <wfm-select-dropdown
            placeholder="{{ 'label.group.select' | translate }}"
            [search]="true"
            [required]="true"
            [items]="listOfWorklists"
            labelField="name"
            [grouping]="true"
            [value]="defaultWorklist"
            (valueChange)="updateDefaultWorklist($event)"
            [translationEnabled]="false"
          ></wfm-select-dropdown>
        </div>
        <div class="u-pb---"  *ngIf="isSRWorkflowEnabled">
          <div>
            <label class="form__label form__label--top form__label--bottom">
            <span class="form__label-inner-wrap">
              <span translate="userPreference.department"></span>
            </span>
            </label>
          </div>
          <wfm-select-dropdown
            placeholder="{{ 'label.department' | translate }}"
            [search]="true"
            [required]="true"
            [items]="listOfDepartment"
            labelField="name"
            [value]="defaultDepartment"
            [disabled]="!defaultDepartmentReady"
            (valueChange)="updateDefaultDepartment($event)"
          ></wfm-select-dropdown>
        </div>
        <div class="u-pb---">
          <label for="color-assignto-column" class="toggle-button toggle-button--blue flex flex--row flex--left flex--middle">
            <input id="color-assignto-column" type="checkbox" class="toggle-button__input"
                   [(ngModel)]="userPreferences.colorAssigntoColumn"
                   (ngModelChange)="updateUserPreference('colorAssigntoColumn', '')"
                   [ngClass]="{ 'toggle-selected': userPreferences.colorAssigntoColumn === true }" />
            <div id="color-assignto-icon" class="toggle-button__label"></div>
            <span class="toggle-button__text toggle-button__text--secondary">{{
              'userPreference.colorAssigntoColumnLabel' | translate
              }}</span>
          </label>
        </div>
        <div class="u-pb---">
          <label for="show-arrived-exams-color" class="toggle-button toggle-button--blue flex flex--row flex--left flex--middle">
            <input
              id="show-arrived-exams-color"
              type="checkbox"
              class="toggle-button__input"
              [(ngModel)]="userPreferences.showArrivedExamsDifferentColor"
              (ngModelChange)="updateUserPreference('showArrivedExamsDifferentColor', '')"
              [ngClass]="{ 'toggle-selected': userPreferences.showArrivedExamsDifferentColor === true }"
            />
            <div id="show-arrived-exams-color-icon" class="toggle-button__label"></div>
            <span class="toggle-button__text toggle-button__text--secondary">{{
              'userPreference.showArrivedExamsRowColor' | translate
            }}</span>
          </label>
        </div>
        <div class="u-pb---" *ngIf="!isEvConfigured">
          <label for="apply-viewer-done-on-tab-close" class="toggle-button toggle-button--blue flex flex--row flex--left flex--middle">
            <input
              id="apply-viewer-done-on-tab-close"
              type="checkbox"
              class="toggle-button__input"
              [(ngModel)]="userPreferences['apply-viewer-done-on-tab-closure']"
              (ngModelChange)="updateUserPreference('apply-viewer-done-on-tab-closure', '')"
              [ngClass]="{ 'toggle-selected': userPreferences['apply-viewer-done-on-tab-closure'] === true }"
            />
            <div id="apply-viewer-done-on-tab-close-icon" class="toggle-button__label"></div>
            <span class="toggle-button__text toggle-button__text--secondary">{{
              'userPreference.applyViewerDoneOnTabClose' | translate
            }}</span>
          </label>
        </div>
        <ng-container *ngIf="isReportingIntegrationConfigured && dictatePrivilege">
          <div *ngIf="isSaveOnTabClosureSupported" class="u-pb---">
            <label for="save-report-on-tab-close" class="toggle-button toggle-button--blue flex flex--row flex--left flex--middle">
              <input
                id="save-report-on-tab-close"
                type="checkbox"
                class="toggle-button__input"
                [(ngModel)]="userPreferences['save-report-on-tab-closure']"
                (ngModelChange)="updateUserPreference('save-report-on-tab-closure', '')"
                [ngClass]="{ 'toggle-selected': userPreferences['save-report-on-tab-closure'] === true }"
              />
              <div id="save-report-on-tab-closure-icon" class="toggle-button__label"></div>
              <span class="toggle-button__text toggle-button__text--secondary">{{
                'userPreference.savePreferenceLabel' | translate
              }}</span>
            </label>
          </div>
          <div class="u-pb---">
            <label for="associable-exam-tab" class="toggle-button toggle-button--blue flex flex--row flex--left flex--middle">
              <input
                id="associable-exam-tab"
                type="checkbox"
                class="toggle-button__input"
                [(ngModel)]="userPreferences.associableExamTab"
                (ngModelChange)="updateUserPreference('associableExamTab', '')"
                [ngClass]="{ 'toggle-selected': userPreferences.associableExamTab === true }"
              />
              <div id="associable-exam-icon" class="toggle-button__label"></div>
              <span class="toggle-button__text toggle-button__text--secondary">{{
                'userPreference.associableExamTab' | translate
              }}</span>
            </label>
          </div>
        </ng-container>
        <div *ngIf="showAutoMinimize && dictatePrivilege" class="u-pb---">
          <label for="auto-minimize-dication" class="toggle-button toggle-button--blue flex flex--row flex--left flex--middle">
            <input
              id="auto-minimize-dication"
              type="checkbox"
              class="toggle-button__input"
              [(ngModel)]="userPreferences.autoMinimizeDictation"
              (ngModelChange)="updateUserPreference('autoMinimizeDictation', '')"
              [ngClass]="{ 'toggle-selected': userPreferences.autoMinimizeDictation === true }"
            />
            <div id="auto-minimize-icon" class="toggle-button__label"></div>
            <span class="toggle-button__text toggle-button__text--secondary">{{
              'userPreference.autoMinimizeDictationLabel' | translate
            }}</span>
          </label>
        </div>
        <div class="u-pb---">
          <label for="auto-launch-viewer" class="toggle-button toggle-button--blue flex flex--row flex--left flex--middle">
            <input
              id="auto-launch-viewer"
              type="checkbox"
              class="toggle-button__input"
              [(ngModel)]="userPreferences.autoLaunchViewerFromExternalSystem"
              (ngModelChange)="updateUserPreference('autoLaunchViewerFromExternalSystem', '')"
              [ngClass]="{ 'toggle-selected': userPreferences.autoLaunchViewerFromExternalSystem === true }"
            />
            <div id="autoLaunchViewerFromExternalSystem-icon" class="toggle-button__label"></div>
            <span class="toggle-button__text toggle-button__text--secondary">{{
              'userPreference.autoLaunchViewerFromExternalSystem' | translate
            }}</span>
          </label>
        </div>
        <div *ngIf="aiFindingsEnable" class="u-pb---">
          <label for="show-ai-findings" class="toggle-button toggle-button--blue flex flex--row flex--left flex--middle">
            <input
              id="show-ai-findings"
              type="checkbox"
              class="toggle-button__input"
              [(ngModel)]="userPreferences.showAiFindings"
              (ngModelChange)="aiFindingsToggle()"
              [ngClass]="{ 'toggle-selected': userPreferences.showAiFindings === true }"
            />
            <div id="aifinding-show-icon" class="toggle-button__label"></div>
            <span id="aifinding-label" class="toggle-button__text toggle-button__text--secondary">{{
              'userPreference.enableAIFindings' | translate
            }}</span>
          </label>
        </div>
        <ng-container *ngIf="nativeAcademicWorkflowEnabled && dictatePrivilege && assignmentPrivilege">
          <div class="u-mt--">
            <label class="form__label form__label--top form__label--bottom">
              <span class="form__label-inner-wrap">
                <span translate="userPreference.nativeAcademicWorkflow"></span>
              </span>
            </label>
          </div>
          <div>
            <label for="academic-workflow" class="u-pb--- toggle-button toggle-button--blue">
              <input
                id="academic-workflow"
                type="checkbox"
                class="toggle-button__input"
                [(ngModel)]="userPreferences.nativeAcademicWorkflow"
                (ngModelChange)="updateUserPreference('nativeAcademicWorkflow', '')"
                [ngClass]="{ 'toggle-selected': userPreferences.nativeAcademicWorkflow === true }"
              />
              <div id="academic-workflow-icon" class="toggle-button__label"></div>
              <span class="toggle-button__text toggle-button__text--secondary">
                {{ 'userPreference.nativeAcademicWorkflow' | translate }}
              </span>
              <div *ngIf="isInstituteSeparationEnabled" class ="academic-workflow-info">
                <svg-icon
                  [tooltip]="'userPreference.nativeAcademicWorkflow.accessWarning' | translate"
                  tooltipWidth="182px"
                  name="ico-info-32"
                  id="academic-workflow-info"
                  [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }">
                </svg-icon>
              </div>
            </label>
          </div>
          <wfm-select-dropdown
            labelField="name"
            [search]="true"
            [required]="false"
            [items]="coReaders"
            [value]="coReader"
            [disabled]="!coReaderEnabled"
            (valueChange)="coReaderValueChange($event)"
          ></wfm-select-dropdown>
        </ng-container>

        <div class="u-mt--">
          <label class="form__label form__label--top form__label--bottom">
            <span class="form__label-inner-wrap">
              <span>{{ 'userPreference.defaultTheme' | translate }}</span>
            </span>
          </label>
        </div>
        <div id="theme-switch" class="flex u-mb">
          <span id="light-text" class="text-16 u-pr-&#45;&#45; u-pt-&#45;&#45;">{{
            'userPreference.light' | translate
          }}</span>
          <div class="button-group">
            <input
              id="light"
              name="appTheme"
              type="radio"
              [value]="true"
              [(ngModel)]="isLightThemeEnabled"
              (change)="toggleTheme()"
            />
            <label for="light" aria-label="Button 1" class="button button&#45;&#45;icon-button u-mr0">
              <svg-icon
                id="theme-lights-on"
                name="ico-brightness-16"
                [ngStyle]="{ width: '16px', height: '16px' }"
                [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
              ></svg-icon>
            </label>
            <input
              id="dark"
              name="appTheme"
              type="radio"
              [value]="false"
              [(ngModel)]="isLightThemeEnabled"
              (change)="toggleTheme()"
            />
            <label for="dark" aria-label="Button 2" class="button button&#45;&#45;icon-button">
              <svg-icon
                id="theme-lights-off"
                name="ico-moon-16"
                [ngStyle]="{ width: '16px', height: '16px' }"
                [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
              ></svg-icon>
            </label>
          </div>
          <span id="dark-text" class="text-16 u-pl-&#45;&#45; u-pt-&#45;&#45;">{{
            'userPreference.dark' | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
